module.exports = __webpack_public_path__ + "static/media/lo-que-sea.12ead756.png";